module.exports = "/_next/static/images/PowerfulIntegrations-49f9f7533412e9d27f6b9ece8a45d249.webp";